import { ActionPanel, Stack, Typography } from '@thirdspacelearning/library';

import errorSvg from '../assets/error.svg';

const ErrorActionPanel = () => {
    const onRefresh = () => {
        window.location.reload();
    };

    return (
        <Stack
            justifyContent="center"
            alignItems="center"
            height="100vh"
            bgcolor="background.default"
        >
            <ActionPanel
                type="error"
                decoration={<img src={errorSvg} alt="An error occurred" />}
                title={'Something went wrong loading the page'}
                textContent={
                    <Typography align="center">
                        Something went wrong initialising Launch Darkly, which
                        will impact your experience. Please ask your IT Lead to
                        contact our support team.
                    </Typography>
                }
                buttonAction={onRefresh}
                buttonLabel={'Refresh page'}
            />
        </Stack>
    );
};

export default ErrorActionPanel;
